/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SearchDoctorBasicInfoRequest = {
  properties: {
    crm: {
      type: 'string',
      isRequired: true,
    },
    uf: {
      type: 'string',
      isRequired: true,
    },
    cpf: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
